import '@/styles/index.css';

import { queryClient } from '@/api/query-client';
import { canonicalizeDevEntry } from '@/auth/dev-entry';
import { resolveRelayTarget } from '@/auth/relay';
import { initializeOperatorCallback, operatorConfig } from '@/auth/runtime';
import { createRoutes } from '@/router';
import { Toaster, TooltipProvider } from '@mgrvtechgroup/admin-ds';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

const devEntry = canonicalizeDevEntry(
  window.location.href,
  import.meta.env.DEV,
  operatorConfig?.redirectUri,
);
// 등록 callback에 프리뷰 로그인 응답이 도착했다면 세션을 건드리지 않고 그 프리뷰 origin으로 되돌린다.
const relayTarget = operatorConfig && resolveRelayTarget(window.location.href, operatorConfig);
if (devEntry) {
  window.location.replace(devEntry);
} else if (relayTarget) {
  window.location.replace(relayTarget);
} else {
  initializeOperatorCallback();
  const router = createBrowserRouter(createRoutes());

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {/* admin-ds Tooltip은 TooltipProvider 없이는 열리지 않는다(Base UI 계약) — 앱 전역에 한 번 감싼다. */}
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster position="top-center" />
        </TooltipProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}
